import {Theme} from "@mui/material";

export function themedScrollbar(theme: Theme) {
    const isDark = theme.palette.mode === "dark";
    const thumbColor = isDark ? "rgba(255,255,255,0.2)" : "rgba(0,0,0,0.2)";
    const thumbHover = isDark ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.35)";
    const trackColor = "transparent";

    return {
        "&::-webkit-scrollbar": {
            width: "6px",
        },
        "&::-webkit-scrollbar-track": {
            background: trackColor,
            borderRadius: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
            background: thumbColor,
            borderRadius: "3px",
            "&:hover": {
                background: thumbHover,
            },
        },
        // Firefox
        scrollbarWidth: "thin" as const,
        scrollbarColor: `${thumbColor} ${trackColor}`,
    };
}
